/* eslint-disable react/no-array-index-key */
import { Row, Col, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  HeadingDescVsmall,
  HeadingWithSpaceLarge
} from '../../../Components/Headings';
import CustomSelect2 from '../../../Components/customSelect2/CustomSelect2';
import HealthCheckLayout from '../healthCheckLayout/HealthCheckLayout';
import CustomInput from '../../../Components/customInput/CustomInput';
import editIcon from '../../../assets/images/png/edit-profile.png';
import { SimpleAncerSmall } from '../../../Components/button';
import './updateProfile.css';
import i18n from '../../../i18n';

const city = [
  { value: 'karachi', label: 'Karachi' },
  { value: 'hederabad', label: 'Hederabad' },
  { value: 'lahore', label: 'Lahore' },
  { value: 'islamabad', label: 'Islamabad' }
];

const gender = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' }
];

const date = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const month = [
  { value: 'jan', label: 'Jan' },
  { value: 'feb', label: 'Feb' },
  { value: 'march', label: 'March' },
  { value: 'april', label: 'April' },
  { value: 'may', label: 'May' }
];

const year = [
  { value: '2003', label: '2003' },
  { value: '2004', label: '2004' }
];

function UpdateProfile() {
  return (
    <HealthCheckLayout>
      <section className="updateProfile bgLinghtGray">
        <Container>
          <HeadingWithSpaceLarge text={i18n.t('add_family_members')} />
          <form>
            <Row>
              <Col md={12}>
                <div className="profileImageBox">
                  <h2 className="profileLetters"> ab </h2>
                  <Link to="/">
                    <img src={editIcon} alt="addIcon" />
                  </Link>
                </div>
              </Col>
              <Col md={4}>
                <HeadingDescVsmall text={i18n.t('phone_number')} />
                <div className="input_box">
                  <span>+92 </span>
                  <input placeholder="" className="custom_input" type="text" />
                </div>
                <HeadingDescVsmall text={i18n.t('city')} />
                <CustomSelect2 options={city} placeholder="" />
                <HeadingDescVsmall text={i18n.t('date_birth')} />
                <div className="dateOfBirth">
                  <div>
                    <CustomSelect2 placeholder="DD" options={date} />
                  </div>
                  <div>
                    <CustomSelect2 placeholder="MM" options={month} />
                  </div>
                  <div>
                    <CustomSelect2 placeholder="YYYY" options={year} />
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <HeadingDescVsmall text="Full Name*" />
                <CustomInput type="text" />
                <HeadingDescVsmall text={i18n.t('gender')} />
                <CustomSelect2 options={gender} placeholder="" />
              </Col>
              <Col md={4}>
                <HeadingDescVsmall text={i18n.t('email_address')} />
                <CustomInput type="text" />
                <Row>
                  <Col md={6}>
                    <HeadingDescVsmall text={i18n.t('height_ft')} />
                    <div className="sizeContainer">
                      <CustomInput type="text" placeholder="FT" />
                      <CustomInput type="text" placeholder="IN" />
                    </div>
                  </Col>
                  <Col md={6}>
                    <HeadingDescVsmall text={i18n.t('weight_kg')} />
                    <CustomInput type="text" />
                  </Col>
                </Row>
                <HeadingDescVsmall text={i18n.t('profile_helping_text')} />
              </Col>
              <Col md={12}>
                <SimpleAncerSmall
                  to="/familyMembers"
                  text={i18n.t('save_changes')}
                />
              </Col>
            </Row>
          </form>
        </Container>
      </section>
    </HealthCheckLayout>
  );
}

export default UpdateProfile;
